import { render, staticRenderFns } from "./FooterShout.vue?vue&type=template&id=a012a710&scoped=true&"
import script from "./FooterShout.vue?vue&type=script&lang=js&"
export * from "./FooterShout.vue?vue&type=script&lang=js&"
import style0 from "./FooterShout.vue?vue&type=style&index=0&id=a012a710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a012a710",
  null
  
)

export default component.exports